module.exports = __webpack_public_path__ + "static/media/alerts-header.fe479e2f.svg";